import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ib-generic-header',
    templateUrl: './ib-generic-header.component.html',
    styleUrls: []
})
export class IbGenericHeaderComponent implements OnInit {

    @Input() headerModel: GenericHeader;
    @Input() imgUrl: string;
    @Input() iconUrl: string;
    @Output('closeModal') closeModal = new EventEmitter<string>();

    constructor (
    ) {
    }

    ngOnInit (): void {
    }

    cancelModal (): void {
        this.closeModal.emit('CANCEL');
    }

}


